import { apiClient } from './axios';
import {
    CreateLibrarySectionRequest,
    DynamicRulesResponse,
    LibrarySection,
    LibrarySectionType,
    SectionOrderItem,
    UpdateLibrarySectionRequest,
} from '../types/library';

export const librarySectionApi = {
    getAll: (type?: LibrarySectionType) =>
        apiClient.get<LibrarySection[]>('/admin/library/sections', {
            type,
        }),

    create: (req: CreateLibrarySectionRequest) =>
        apiClient.post<LibrarySection>('/admin/library/sections', req),

    update: (id: number, req: UpdateLibrarySectionRequest) =>
        apiClient.put<LibrarySection>(`/admin/library/sections/${id}`, req),

    delete: (id: number) => apiClient.deleteNoData(`/admin/library/sections/${id}`),

    reorder: (items: SectionOrderItem[]) =>
        apiClient.putNoData('/admin/library/sections/reorder', { items }),

    normalize: () => apiClient.postNoData('/admin/library/sections/normalize'),

    getDynamicRules: () =>
        apiClient.get<DynamicRulesResponse>('/admin/library/sections/dynamic-rules'),
};
